import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface HeaderConfig {
    title: string;
    buttons: {
        label: string;
        action?: () => void; // Make action optional
        type: 'primary' | 'secondary' |'dark' | 'dropdown'; // Add dropdown type
        disabled?: boolean;
        dropdownItems?: { label: string; action: () => void , icon?: string;}[]; // Support dropdown items
    }[];
}

@Injectable({
    providedIn: 'root'
})
export class HeaderService {
    private configSubject = new BehaviorSubject<HeaderConfig>({
        title: '',
        buttons: []
    });

    config$ = this.configSubject.asObservable();

    setConfig(config: HeaderConfig) {
        this.configSubject.next(config);
    }

    getConfig() {
        return this.configSubject.getValue();
    }

  updateButtonState(label: string, disabled: boolean) {
    const currentConfig = this.configSubject.getValue();
    const updatedButtons = currentConfig.buttons?.map(button =>
      button.label === label ? { ...button, disabled } : button
    ) || [];
    this.configSubject.next({ ...currentConfig, buttons: updatedButtons });
  }
}
